import { inject, Pipe, PipeTransform } from '@angular/core';
import { ConfigService } from '../../services/config.service';
import { catchError, map, Observable, of } from 'rxjs';

@Pipe({
  name: 'dynamicText'
})
export class DynamicTextPipe implements PipeTransform {
  private config: any;
  private configService = inject(ConfigService);

  constructor() {
    this.configService.getConfig().subscribe((config) => {
      this.config = config;
    });
  }

  transform(key: string): Observable<string> {
    if (!this.config) {
      return this.configService.getConfig().pipe(
        map((config) => {
          return config.titles[key] || key;
        }),
        catchError(() => of(key))
      );
    } else {
      return of(this.config.titles[key] || key);
    }
  }
}
